import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/adhoc/Data Table/index";

// import DataTable_Component from "../../components/DataTable/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Layouts from "../../layouts/layouts";
import AdhocDetailModal from "../../components/adhoc/Adhoc Details";
import * as XLSX from "xlsx"; // Import XLSX library for Excel export
import Switch from "react-switch";

export default function Adhoc() {
  const title = "Adhoc User Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showAdhocDetailModal, setShowAdhocDetailModal] = useState(false);
  const [selectedAdhoc, setSelectedAdhoc] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const columns = [
    {
      name: <b>Name</b>,
      selector: (row) => row.id_adhocUser?.name || "N/A",
      sortable: true,
    },

    {
      name: <b>Vehicle Number</b>,
      selector: (row) => row.id_vehicle?.numberplate || "N/A",
      sortable: true,
    },
    {
      name: <b>Phone Number</b>,
      selector: (row) => row.id_adhocUser?.phone_number || "N/A",
      sortable: true,
    },
    {
      name: <b>Payment</b>,
      selector: (row) => row.payment || 0,
      sortable: true,
    },
    {
      name: <b>Client Name</b>,
      selector: (row) => row.id_client?.name || "N/A",
      sortable: true,
    },
    {
      name: <b>Attendance Date</b>,
      selector: (row) =>
        new Date(row.date).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
      sortable: true,
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          <button
            onClick={() => viewAdhoc(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        </>
      ),
    },
  ];

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const fetchData = async (page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v3/attendance/adhoc`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (Array.isArray(response.data.adhocUserAttendance)) {
        setApiState(response.data.adhocUserAttendance);
      } else {
        console.error("Unexpected data format from API", response.data);
      }
      setApiCol(columns);
    } catch (error) {
      console.log("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const copyLink = () => {
    alert(46);
  };

  const viewAdhoc = (adhoc) => {
    setSelectedAdhoc(adhoc);
    setShowAdhocDetailModal(true);
  };

  const exportToExcel = () => {
    const transformedData = apistate.map((adhoc) => ({
      Name: adhoc.id_adhocUser?.name || "N/A",
      "Vehicle Number": adhoc.id_vehicle?.numberplate || "N/A",
      "Phone Number": adhoc.id_adhocUser?.phone_number || "N/A",
      Payment: adhoc.payment || 0,
      "Client Name": adhoc.id_client?.name || "N/A",
      "Attendance Date": new Date(adhoc.date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Adhoc Users");

    XLSX.writeFile(workbook, "adhoc_users.xlsx");
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <AdhocDetailModal
        show={showAdhocDetailModal}
        onHide={() => setShowAdhocDetailModal(false)}
        adhoc={selectedAdhoc}
      />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="name"
                    title="Adhoc List"
                    apidata={apistate}
                    columns={apicol}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
